module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', {
    directives: [{
      name: "lang",
      rawName: "v-lang.contacto",
      modifiers: {
        "contacto": true
      }
    }]
  }), _vm._v(" "), _c('address', [_c('ul', {
    staticClass: "address_details"
  }, [_c('li', [_c('i', {
    staticClass: "glyphicon glyphicon-map-marker"
  }), _vm._v(" " + _vm._s(_vm.address))]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "glyphicon glyphicon-phone-alt"
  }), _vm._v(" " + _vm._s(_vm.phone) + " ")]), _vm._v(" "), (_vm.fax != null) ? _c('li', [_c('i', {
    staticClass: "fa fa-fax"
  }), _vm._v(" " + _vm._s(_vm.fax))]) : _vm._e(), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-envelope"
  }), _c('a', {
    attrs: {
      "href": _vm.adddressMail
    }
  }, [_vm._v(_vm._s(_vm.email))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-426f39da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/Contact.vue
// module id = 359
// module chunks = 0